import { Card, CardActionArea, InputLabel } from '@mui/material';
import React, { useImperativeHandle } from 'react';
import placeholderImageUrl from 'src/assets/images/placeholder.png';
import { useModal } from 'src/hooks';
import { IGcfProductListProductImage } from 'src/interfaces';
import { lang } from 'src/utils';

import { WidgetsCommonProps } from '../widget.interface';
import {
  AutorenewIconStyled,
  ImagePreview,
  Wrapper,
} from './ResourceSelector.styled';
import { ResourceSelectorSidebar } from './resourceSelectorSidebarWidget/ResourceSelectorSidebar';
import { ResourceType } from './resourceSelectorSidebarWidget/ResourceSelectorSidebar.interface';
import { ThemeAssetsSelectorDrawer } from './themeAssetsSelectorDrawer/ThemeAssetsSelectorDrawer';

export const ResourceSelectorWidget = React.forwardRef(
  (
    props: WidgetsCommonProps & {
      showThemeSelector?: boolean;
      enableUploadProductImages?: boolean;
      productCode?: string;
      productImage?: IGcfProductListProductImage;
      hasSupportingProduct?: boolean;
    },
    ref,
  ) => {
    const {
      open: openResourceSelectorDrawer,
      onCloseModal: onCloseResourceSelectorDrawer,
      onToggleModal: onToggleResourceSelectorDrawer,
    } = useModal();
    const themeAssetsSelectorDrawer = useModal();

    const handleAssetChange = (
      assetNameValue: string | null,
      productVariationCode?: string,
    ) => {
      const updatedImage = props.hasSupportingProduct
        ? {
            ...props.productImage,
            assetName: assetNameValue,
            productCode: productVariationCode,
            visible: assetNameValue ? true : false, // If assetNameValue is null (user selects noImage), set visible to false
          }
        : {
            ...props.productImage,
            assetName: assetNameValue,
            visible: assetNameValue ? true : false, // If assetNameValue is null (user selects noImage), set visible to false
          };
      props.onChange(updatedImage);

      onCloseResourceSelectorDrawer();
      themeAssetsSelectorDrawer.onCloseModal();
    };

    const handleImageClick = () => {
      props.showThemeSelector
        ? themeAssetsSelectorDrawer.onToggleModal()
        : onToggleResourceSelectorDrawer();
    };

    useImperativeHandle(ref, () => ({
      handleImageClick,
    }));

    return (
      <Wrapper ref={ref}>
        <InputLabel>{props.label}</InputLabel>

        <Card sx={{ maxWidth: 150 }}>
          <CardActionArea disabled={props.disabled}>
            {!props.disabled && <AutorenewIconStyled color="primary" />}

            <ImagePreview
              image={props.value || placeholderImageUrl}
              onClick={handleImageClick}
            />
          </CardActionArea>
        </Card>

        <ThemeAssetsSelectorDrawer
          {...themeAssetsSelectorDrawer}
          label={lang.selectImage}
          productCode={props.productCode}
          onRightButtonClick={onToggleResourceSelectorDrawer}
          handleAssetChange={handleAssetChange}
          enableUploadProductImages={props.enableUploadProductImages!}
        />

        <ResourceSelectorSidebar
          label={lang.selectMore}
          ref={ref}
          type={ResourceType.PRODUCT}
          defaultAssetName={props.value}
          openResourceSelectorDrawer={openResourceSelectorDrawer}
          onToggleResourceSelectorDrawer={onToggleResourceSelectorDrawer}
          onChange={handleAssetChange}
        />
      </Wrapper>
    );
  },
);
